import React from "react";
import FieldLabel from "../atoms/FieldLabel";
import FieldMessage from "../atoms/FieldMessage";

// Molecule: Field = Field Label + control (children) + Field Message.
// This is the single shell every Quick Form field composes from — text, phone,
// and select fields all render through it. Changing the structure here changes
// every field at once (QA Proof #4). The concrete control atom is passed as
// children so this shell stays control-agnostic.
const Field = ({ label, htmlFor, required = false, error, errorClassName, children }) => (
    <div className="smww-field" data-atomic="molecule" data-atomic-name="field">
        <FieldLabel htmlFor={htmlFor} required={required}>
            {label}
        </FieldLabel>
        {children}
        {error && <FieldMessage className={errorClassName}>{error}</FieldMessage>}
    </div>
);

export default Field;
